import React from 'react';

import teamMapData from '~/data/sidebar/team_map.json';
import teamMap from '~/images/world-bunny-team-map.svg';

interface TeamMapProps {
  block: {
    _template: string;
    css_class_name: string;
  };
  countries?: {
    _template: string;
    countries: Pin[];
  };
}

interface Pin {
  name: string;
  map_position_top: string;
  map_position_left: string;
  pin_size: string;
  flag?: string;
  color?: string;
}

const TeamMap: React.FC<TeamMapProps> = ({ block, countries }) => {
  const pinData = countries || teamMapData;

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container'>
        <div className='team-map-wr'>
          <img
            src={teamMap}
            alt='Team Map - bunny.net'
            title='Team Map - bunny.net'
          />
          <ul className='team-pins'>
            {pinData.countries.map((pin: Pin) => {
              return (
                <li
                  key={pin.name}
                  className={`pin ${pin.pin_size}`}
                  style={{
                    top: `${pin.map_position_top}`,
                    left: `${pin.map_position_left}`,
                  }}
                >
                  <div
                    className='bunny-pin'
                    style={{
                      backgroundColor: pin.color || '#fff',
                    }}
                  >
                    <img
                      className='bunny-pin__flag'
                      src={pin.flag || '/images/bunny-flag.png'}
                      alt={pin.name}
                    />
                  </div>
                  <div className='label'>{pin.name}</div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TeamMap;
